module.exports = __webpack_public_path__ + "img/product_analytic.c656b211.svg";